import React, { useCallback, useState } from 'react';
import { ErrorBoundary } from "@appsignal/react";
import { Notification } from './components/Notification/Notification';
import { QuizRow } from './components/QuizRow/QuizRow';
import { LightboxComponent } from '@company/components/LightboxComponent/LightboxComponent';
import { QuizTemplate } from '@bundles/otherApps/CelsiusQuizApp/components/QuizTemplate/QuizTemplate';
import CelsiusQuizService from '@services/CelsiusQuiz.service';

import { appsignal } from "./../../appsignal";
import * as style from './CelsiusQuizAppStyle.module.scss'

export type Profile = {
  celsius_quiz_result: boolean;
};

type Props = {
  profile: Profile;
};

export const CelsiusQuizApp = ({
  profile,
}: Props) => {
  const [showQuiz, setShowQuiz] = useState(false);
  const [currentProfile, setCurrentProfile] = useState(profile);

  const emptyNotification = (<></>);

  const quizNotification = (
    <Notification>
      <>
        <span>
          Celsius quiz is required when using celsius payment method.
        </span>
      </>
    </Notification>
  );

  const errorNotification = (
    <Notification>
      <>
        <span>
          Celsius quiz is required when using celsius payment method.
        </span>
        <br/>
        <span>
          Your answers were incorrect.
        </span>
      </>
    </Notification>
  );
  const isCelsiusQuizCompleted = currentProfile.celsius_quiz_result;
  const [notification, setNotification] = useState(isCelsiusQuizCompleted ? emptyNotification : quizNotification);
  const closeQuiz = () => setShowQuiz(false);

  const showCelsiusQuiz = useCallback(
    async () => {
      setShowQuiz(true);
    },
     [setShowQuiz]
  );

  const onQuizSubmit = async (data: object) => {
    const response = await CelsiusQuizService.completeCelsiusQuiz(data);
    if (response === 'success') {
      setCurrentProfile((prev) => ({ ...prev, celsius_quiz_result: true }));
      setNotification(emptyNotification);
      // @ts-ignore
      document.querySelector('input[type=submit]').disabled = false;
    } else {
      setNotification(errorNotification);
    }
  };

  return (
    <ErrorBoundary instance={appsignal}>
      <div id='celsiusQuizApp' className={style.celsiusQuizApp}>
        {notification}

        <QuizRow
          label="Celsius quiz required"
          isSigned={isCelsiusQuizCompleted}
          handleShowQuizClick={showCelsiusQuiz}
        />

        <LightboxComponent
          isVisible={showQuiz}
          closePreview={closeQuiz}
        >
          {
            <QuizTemplate
              profile={currentProfile}
              closeModal={closeQuiz}
              onSubmit={onQuizSubmit}
            />
          }
        </LightboxComponent>
      </div>
    </ErrorBoundary>
  );
};
export default (props: Props) => <CelsiusQuizApp {...props} />;
